<template>
  <div class="">
    <div class="mb-3 mx-auto lg:mx-32">
      <loader v-if="loader"></loader>
      <div class="px-5 bg-white rounded-lg shadow">
        <br>
        <card_observacion_component v-if="this.$route.params.id==='proceso'">
          <div slot="body" class="pb-3">
            <br>
            <p class="text-left px-4 pb-3">
              Si está realizando registro rápido para descarga de documentos, los adjuntos solicitados no son
              requeridos</p>
            <br>
          </div>
        </card_observacion_component>
        <stepper :items="parametros" :active-class="ActiveClass" :normal-class="normalClass"></stepper>
        <div v-if="step===1">
          <registrar_proveedor :informacion_empresa_props="informacion_empresa" :ubicacion_props="ubicacion"
                               :dato_contacto_props="dato_contacto"></registrar_proveedor>
        </div>
        <div v-if="step===2">
          <registrar_representante_legal
              :informacion_representante_props="informacion_representante"
              :informacion_autorizado_legal_props="informacion_autorizado_legal"
              :id_tipo_persona="informacion_empresa.tipo_personeria.value">
          </registrar_representante_legal>
        </div>
        <div class="grid xl:gap-14 lg:gap-14 xs:gap-3  sm:gap-3 md:gap-3  pt-10 xs:pb-20"
             :class="step>=2 && step<parametros.length?'grid-cols-3 ':'grid-cols-2'">
          <div class="text-right" v-if="step===2">
            <button class=" focus:outline-none uppercase bg-primary text-white
             xl:px-10 xs:px-5 sm:px-5 md:px-5 py-2 rounded-full" @click="stepper(2)">
              Anterior
            </button>
          </div>
          <div :class="step<2?'text-right':'text-center'" v-if="this.step<parametros.length">
            <button class=" focus:outline-none uppercase bg-primary text-white  py-2
            xl:px-10 xs:px-5 sm:px-5 md:px-5 rounded-full" @click="stepper(1)">
              Siguiente
            </button>
          </div>
          <div class="text-center" v-if="this.step===parametros.length">
            <button class=" focus:outline-none uppercase bg-primary text-white  py-2
            xl:px-10 xs:px-5 sm:px-5 md:px-5 rounded-full" @click="GuardarDatos()">
              GUARDAR
            </button>
          </div>
          <div class="text-left">
            <button class=" focus:outline-none uppercase bg-gray-200 text-gray-900 font-bold  py-2
            xl:px-10 xs:px-4 sm:px-5 md:px-5 rounded-full
              border-gray-500 border" @click="cancelar()">
              CANCELAR
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import registrar_proveedor from "./registrar_proveedor";
import registrar_representante_legal from "./registrar_representante_legal";
import Documentos_proveedor from "./documentos_proveedor";
import Card_observacion_component from "../../../components/card_observacion_component";
import {mapActions, mapGetters} from "vuex";
import {isNit, isDui} from '@/plugins/shared'

export default {
  components: {Documentos_proveedor, registrar_proveedor, registrar_representante_legal, Card_observacion_component},
  data: () => ({
    url: process.env.VUE_APP_API_URL,
    informacion_empresa: [],
    ubicacion: [],
    dato_contacto: [],
    InfoEmpresa: [],
    validEmailConfirmation:null,
    parametros: [
      {codigo: 1, name: 'Identificación de la empresa', isActive: true, icon: '1'},
      {codigo: 2, name: 'Información del representante legal', isActive: false, icon: '2'},
      {codigo: 3, name: 'Documentos legales del proveedor', isActives: false, icon: '3'},
    ],
    ActiveClass: {
      text_color: 'text-primary',
      icon_color: 'text-white',
      boder_color: 'border-primary',
      bg_color: 'bg-primary',
      line_color: 'bg-gray-500'
    },
    normalClass: {
      text_color: 'text-gray-500',
      boder_color: 'border-gray-500',
      bg_color: '',
      icon_color: 'text-gray-500',
      line_color: 'bg-gray-500'
    },
    step: 1,
    id_persona: window.localStorage.getItem('informacion_representante'),
    informacion_representante: {
      numero_dui: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      numero_carnet: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      foto_dui: {
        value: null,
        state: false,
        message: 'campo es requerido'
      },
      numero_nit: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      foto_nit: {
        value: null,
        state: false,
        message: 'campo es requerido'
      },
      primer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      primer_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      fecha_nacimiento: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      sexo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      cargo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      nacionalidad: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      empresa: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      institucion: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      apellido_casada: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      tercer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      id_persona: 0,
      nombre: null
    },
    informacion_autorizado_legal: {
      numero_dui: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      numero_nit: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      foto_nit: {
        value: null,
        state: false,
        message: 'campo es requerido'
      },
      primer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      primer_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      fecha_nacimiento: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      sexo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      cargo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      nacionalidad: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      empresa: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      institucion: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      apellido_casada: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      tercer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      correo_empresa: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      telefonos: {
        value: [],
        state: null,
        message: 'campo es requerido'
      },
      id_persona: 0,
      nombre: null
    },
    verificacion: false,
    tiposEmpresas: [],
    loader: false,
    girosempresa: [],
    exito: 0
  }),
  methods: {
    async stepper(tipo) {
      this.loader = true
      // 1 es siguiente y 2 es anterior
      if (tipo === 1 && this.step < this.parametros.length) {
        this.parametros.forEach(row => {
          if (row.codigo === this.step && this.step !== 3) {
            row.isActive = true
          }
        })
        if (this.step === 1) {
          this.GuardarDataFormulario()
        }
        if (this.step === 2) {
          this.GuardarDataFormularioPersona();
        }

        if (this.step === this.parametros.length) {

          this.$router.push('/empresas/final');
        }

      } else if (tipo === 2) {
        this.parametros.forEach(row => {
          if (row.codigo === this.step && this.step !== 3) {
            row.isActive = false
            this.step = this.step - 1
          }
        })
      }
      this.GuardarDatos()
    },
   async relacionarInfoRepresentante(process) {
     this.validEmailConfirmation = JSON.parse(window.localStorage.getItem('isValidConfirmation'))
      let contacts = []
     this.informacion_autorizado_legal.telefonos.value.forEach(row => {
        contacts.push({'id_type_contact': 1, 'value_contact': row.Telefono})
      })
        contacts.push({'id_type_contact': 2, 'value_contact':this.informacion_autorizado_legal.correo_empresa.value})


      let id = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
      let id_persona_representate = JSON.parse(window.localStorage.getItem('informacion_representante'))
      let id_persona_autorizado = JSON.parse(window.localStorage.getItem('informacion_autorizado_legal'))
      let isRL = false
     if(id_persona_representate.numero_carnet.value !== null ) {
        isRL = true
     }


      if (id_persona_representate.id_persona > 0 && this.informacion_autorizado_legal.isValidEmail === true  && this.validEmailConfirmation === true) {
        try {
          let processRegister = localStorage.getItem('processRegister');
          let form = new FormData();
          const headers = {'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'}
          form.append('id_representante',id_persona_representate.id_persona);
          form.append('id_contacto_persona',id_persona_autorizado.id_persona);
          form.append('id_cargo',1);
          form.append('id_empresa',id.id);
          form.append('id_estado',3);
          form.append('edit', true);
          form.append('contacts', JSON.stringify(contacts));
          if(processRegister){
            form.append('isSendMailProfile',processRegister);
          }
          if(!process){
            form.append('process', 'false');
            if(isRL === true){
              form.append('carnet_file', this.fotoCarnetPersona ? this.fotoCarnetPersona : null );
              form.append('type_document', 2);
            }else{
              form.append('type_document', 1);
              form.append('dui_file', this.fotoDuiPersona ? this.fotoDuiPersona : null );
              form.append('nit_file', this.fotoNitPersona ? this.fotoNitPersona :null);
            }
          }else{
            form.append('process', 'true');
          }
          let response = await this.http_client('/api/v1/providers/providerperson', form, 'POST', headers);
          if (response.status === 201) {
            window.localStorage.clear()
            await this.$router.push('/empresas/final')
          }
        } catch (e) {
          this.$toast.warning(e.response.data.message)
        }
      }
    },
    async GuardarDataFormularioPersona() {
      if (JSON.parse(window.localStorage.getItem('informacion_representante'))) {
        this.informacion_representante = JSON.parse(window.localStorage.getItem('informacion_representante'))

      }
      if (JSON.parse(window.localStorage.getItem('informacion_autorizado_legal'))) {
        this.informacion_autorizado_legal = JSON.parse(window.localStorage.getItem('informacion_autorizado_legal'))


      }
      this.informacion_autorizado_legal.numero_dui.value == null || this.informacion_autorizado_legal.numero_dui.value === ''
          ? this.informacion_autorizado_legal.numero_dui.state = true : this.informacion_autorizado_legal.numero_dui.state = false

      this.informacion_representante.numero_nit.value == null || this.informacion_representante.numero_nit.value === ''
          ? this.informacion_representante.numero_nit.state = true : this.informacion_representante.numero_nit.state = false

      this.informacion_representante.numero_dui.value == null || this.informacion_representante.numero_dui.value === ''
          ? this.informacion_representante.numero_dui.state = true : this.informacion_representante.numero_dui.state = false

      try {
        if (this.$route.params.id === 'proceso') {
          if (this.informacion_autorizado_legal.correo_empresa.value !== null && this.informacion_autorizado_legal.correo_empresa.value !== '') {


           // await this.GuardarDatosCorreoPersona(this.informacion_autorizado_legal.correo_empresa.value)
            await this.relacionarInfoRepresentante(true)


          } else {
            this.informacion_autorizado_legal.correo_empresa.value == null || this.informacion_autorizado_legal.correo_empresa.value === ''
                ? this.informacion_autorizado_legal.correo_empresa.state = true : this.informacion_autorizado_legal.correo_empresa.state = false
          }
        } else {
          if(this.informacion_representante.numero_carnet.value !==null || this.informacion_representante.numero_carnet.value !== ''){
            if (this.informacion_autorizado_legal.correo_empresa.value !== null && this.informacion_autorizado_legal.correo_empresa.value !== '') {
              //await this.GuardarDatosCorreoPersona(this.informacion_autorizado_legal.correo_empresa.value)
              await this.relacionarInfoRepresentante(false)

              this.setData()
              await this.http_client('/api/v1/empresas/' + this.InfoEmpresa.id + '/nueva_empresa', {}, 'post')
            } else {
              this.informacion_autorizado_legal.correo_empresa.value == null || this.informacion_autorizado_legal.correo_empresa.value === ''
                  ? this.informacion_autorizado_legal.correo_empresa.state = true : this.informacion_autorizado_legal.correo_empresa.state = false

              this.fotoNitPersona == null || this.fotoNitPersona.length === 0
                  ? this.informacion_representante.foto_nit.state = true : this.informacion_representante.foto_nit.state = false

              this.fotoDuiPersona == null || this.fotoDuiPersona.length === 0
                  ? this.informacion_representante.foto_dui.state = true : this.informacion_representante.foto_dui.state = false
            }
          }else{
            if (this.informacion_autorizado_legal.correo_empresa.value !== null && this.informacion_autorizado_legal.correo_empresa.value !== ''
                && this.fotoNitPersona !== null && this.fotoNitPersona !== '' && this.fotoNitPersona.length !== 0 && this.fotoDuiPersona !== null && this.fotoDuiPersona.length !== 0) {
              //await this.GuardarDatosCorreoPersona(this.informacion_autorizado_legal.correo_empresa.value)

             await this.relacionarInfoRepresentante(false)

              this.setData()
              await this.http_client('/api/v1/empresas/' + this.InfoEmpresa.id + '/nueva_empresa', {}, 'post')
            } else {
              this.informacion_autorizado_legal.correo_empresa.value == null || this.informacion_autorizado_legal.correo_empresa.value === ''
                  ? this.informacion_autorizado_legal.correo_empresa.state = true : this.informacion_autorizado_legal.correo_empresa.state = false

              this.fotoNitPersona == null || this.fotoNitPersona.length === 0
                  ? this.informacion_representante.foto_nit.state = true : this.informacion_representante.foto_nit.state = false

              this.fotoDuiPersona == null || this.fotoDuiPersona.length === 0
                  ? this.informacion_representante.foto_dui.state = true : this.informacion_representante.foto_dui.state = false
            }
          }

        }
      } catch (e) {
      } finally {
        this.loader = false
      }
    },
    async GuardarDataFormulario() {
      let regexp = /^[\w]+([\.]+[\w]+)+$/
      let infoRepre
      if (JSON.parse(window.localStorage.getItem('informacion_representante'))) {
        infoRepre = JSON.parse(window.localStorage.getItem('informacion_representante'))
      }
      let infoAuto
      if (JSON.parse(window.localStorage.getItem('informacion_autorizado_legal'))) {
        infoAuto = JSON.parse(window.localStorage.getItem('informacion_autorizado_legal'))
      }
      if (!infoRepre) {
        infoRepre = window.localStorage.setItem('informacion_representante', JSON.stringify(this.informacion_representante))
      }
      if (!infoAuto) {
        window.localStorage.setItem('informacion_autorizado_legal', JSON.stringify(this.informacion_autorizado_legal))
      }

      this.setData()
      // validData
      const re15Digit2Decimal = /^\d{0,15}(\.\d{0,2})?$/;
      const re4Digit = /^\d{0,4}?$/;
      let long_nombre_empresa = false
      let long_nombre_comercial_empresa = false
      let long_numero_matricula_comercial = false
      let long_sales = false
      let long_experiencia = false
      let long_direccion = false
      let long_correo_empresa = false
      let long_sitio_web= false
      if (this.informacion_empresa.nombre_empresa.value !== null &&
          this.informacion_empresa.nombre_empresa.value !== '') {
        if (this.informacion_empresa.nombre_empresa.value.length <= 100){
          long_nombre_empresa = true
        }
      }
      if (this.informacion_empresa.nombre_comercial_empresa.value !== null &&
          this.informacion_empresa.nombre_comercial_empresa.value !== '') {
        if (this.informacion_empresa.nombre_comercial_empresa.value.length <= 100){
          long_nombre_comercial_empresa = true
        }
      }else{
        long_nombre_comercial_empresa = true
      }
      if (this.informacion_empresa.numero_matricula_comercial.value !== null &&
          this.informacion_empresa.numero_matricula_comercial.value !== '') {
        if (this.informacion_empresa.numero_matricula_comercial.value.length <= 50){
          long_numero_matricula_comercial = true
        }
      } else if (this.informacion_empresa.tipo_personeria.value === 1) {
        long_numero_matricula_comercial = true
      }
      if (this.informacion_empresa.sales.value !== null &&
          this.informacion_empresa.sales.value !== '') {
        if ((re15Digit2Decimal.test(this.informacion_empresa.sales.value))) {
          long_sales = true
        }
      }
      if (this.informacion_empresa.experiencia.value !== null &&
          this.informacion_empresa.experiencia.value !== '') {
        if ((re4Digit.test(this.informacion_empresa.experiencia.value))) {
          long_experiencia = true
        }
      }
      if (this.ubicacion.direccion.value !== null &&
          this.ubicacion.direccion.value !== '') {
        if (this.ubicacion.direccion.value.length <= 255){
          long_direccion = true
        }
      }
      if (this.dato_contacto.correo_empresa.value !== null &&
          this.dato_contacto.correo_empresa.value !== '') {
        if (this.dato_contacto.correo_empresa.value.length <= 100){
          long_correo_empresa = true
        }
      }
      if (typeof(this.dato_contacto.sitio_web.value) === 'undefined' || this.dato_contacto.sitio_web.value === '') this.dato_contacto.sitio_web.value = null
      if (typeof(this.dato_contacto.sitio_web.value) !== 'undefined' &&
          this.dato_contacto.sitio_web.value !== null &&
          this.dato_contacto.sitio_web.value !== '') {
        if (this.dato_contacto.sitio_web.value.length <= 100){
          long_sitio_web = true
        }
      } else {
        long_sitio_web = true
      }

      let validaNit = this.validateNitEmpresa()
      let validaNRC = this.validateNRCEmpresa()
      if (validaNit && validaNRC
          && this.informacion_empresa.numero_nit.value !== null && this.informacion_empresa.numero_registro.value !== null
          && this.informacion_empresa.nombre_empresa.value !== null
          && this.informacion_empresa.pais_origen_empresa.value !== null && this.informacion_empresa.tipo_personeria.value !== null
          && this.informacion_empresa.tamano_empresa.value !== null
          && this.informacion_empresa.experiencia.value !== null && this.informacion_empresa.numero_nit.value !== ''
          && this.informacion_empresa.numero_registro.value !== ''
          && this.informacion_empresa.nombre_empresa.value !== ''
          && long_nombre_empresa
          && long_nombre_comercial_empresa
          && long_numero_matricula_comercial
          && long_sales
          && long_experiencia
          && long_direccion
          && long_correo_empresa
          && long_sitio_web
          && (regexp.test(this.dato_contacto.sitio_web.value) || this.dato_contacto.sitio_web.value === null)
          && this.informacion_empresa.pais_origen_empresa.value !== '' && this.informacion_empresa.tipo_personeria.value !== ''
          && this.informacion_empresa.tamano_empresa.value !== ''
          && this.informacion_empresa.experiencia.value !== ''
          && this.ubicacion.municipio.value !== null && this.ubicacion.direccion.value !== null
          && this.dato_contacto.correo_empresa.value !== null
          && this.ubicacion.municipio.value !== '' && this.ubicacion.direccion.value !== ''
          && this.dato_contacto.correo_empresa.value !== ''
          && this.informacion_empresa.sales.value && this.informacion_empresa.sales.value !== ''
          && this.validateForm()
          && this.validateDocuments()
          && this.informacion_empresa.giros.value !== null
          && this.informacion_empresa.giros.value !== ''
          && this.informacion_empresa.giros.value.length > 0
          && this.informacion_empresa.giros.value.length < 4
          && this.dato_contacto.telefonos.value !== null
          && this.dato_contacto.telefonos.value !== ''
          && this.dato_contacto.telefonos.value.length > 0
          && this.dato_contacto.telefonos.value.length < 4
          && (this.fotoRnc.length !== 0 || this.$route.params.id === "proceso")
          && (this.fotoNit.length !== 0 || this.$route.params.id === "proceso")
          // && this.informacion_empresa.isValidEmail==true
      ) {
        axios.get(this.url + '/api/v1/providers/validNIT?'
            + 'id=' + this.InfoEmpresa.id
            + '&nit=' + this.informacion_empresa.numero_nit.value
            + '&nrc=' + this.informacion_empresa.numero_registro.value,
            {
              headers: {
                'Content-Type': 'application/json',
              }
            }).then(async (response) => {
          if(this.InfoEmpresa.tipoEmpresa === 1){
          this.InfoEmpresa.tipos.forEach(row => {
            let tipoExiste = this.tiposEmpresas.find(Tipo => Tipo.id_tipo_empresa === row.id_tipo_empresa);
            if (!tipoExiste) {
              this.tiposEmpresas.push({'id_tipo_empresa': row.id_tipo_empresa})
            }
          })
          }
          let contacts = []
          this.dato_contacto.telefonos.value.forEach(row => {
            contacts.push({'id_type_contact': 1, 'value_contact': row.Telefono})
          })
          let transactions = []
          this.informacion_empresa.giros.value.forEach(row => {
            transactions.push({
              'id_type_transaction': row['No.'],
              'id_transaction': row['id_giro'],
              'name_transaction': row['Actividad o giro']
            })
          })
          this.loader = false
          let processRegister = localStorage.getItem('processRegister');
          let form = new FormData();
          const headers = {'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'}
          if (this.$route.params.id === "proceso") {
            form.append('process', 'true');
          } else {
            form.append('process', 'false');
          }
          if(processRegister){
            form.append('isSendMailProfile',processRegister);
          }
          form.append('id', this.InfoEmpresa.id);

          form.append('isPublic', 'true');
          form.append('nrc', this.informacion_empresa.numero_registro.value);

          form.append('nit', this.informacion_empresa.numero_nit.value);
          form.append('nombre_empresa', this.informacion_empresa.nombre_empresa.value);
          form.append('nombre_comercial', this.informacion_empresa.nombre_comercial_empresa.value === ''
              ? null : this.informacion_empresa.nombre_comercial_empresa.value);
          form.append('id_pais', this.informacion_empresa.pais_origen_empresa.value);
          form.append('id_tipo_persona', JSON.stringify(this.informacion_empresa.tipo_personeria.value));
          form.append('matricula_comercial', this.informacion_empresa.numero_matricula_comercial.value);
          form.append('id_tamanio_empresa', this.informacion_empresa.tamano_empresa.value);
          form.append('id_municipio', this.ubicacion.municipio.value);
          form.append('direccion', this.ubicacion.direccion.value);
          form.append('sitio_web', this.dato_contacto.sitio_web.value !== "" ?
              this.dato_contacto.sitio_web.value : null);
          form.append('anios_experiencia', this.informacion_empresa.experiencia.value);
          form.append('email', this.dato_contacto.correo_empresa.value);
          if(this.InfoEmpresa.tipoEmpresa === 1){
            form.append('tipos', JSON.stringify(this.tiposEmpresas));
          }

          form.append('providerTypeId', JSON.stringify(this.InfoEmpresa.tipoEmpresa));
          form.append('sales', this.informacion_empresa.sales.value);
          if (typeof(this.fotoRnc.name) !== 'undefined') form.append('nrc_file', this.fotoRnc);
          if (typeof(this.fotoNit.name) !== 'undefined') form.append('nit_file', this.fotoNit);
          form.append('contacts', JSON.stringify(contacts));
          form.append('transactions', JSON.stringify(transactions));
          let responseProviders = await this.http_client(`/api/v1/providers`, form, 'POST', headers);
          if (responseProviders.status === 201 || responseProviders.status === 200) {
            window.localStorage.setItem('InfoEmpresas', JSON.stringify(responseProviders.data))

            this.InfoEmpresa = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
            this.step = this.step + 1
            this.parametros.forEach(row => {
              if (row.codigo === this.step) {
                row.isActive = true
              }
            })
          }
          this.loader = false
        }).catch(error => {
          this.$toast.warning(error.response.data.message)
          this.loader = false
          return false
        })
        // axios.post(this.url + '/api/v1/empresas',
        //     {
        //       "nit": this.informacion_empresa.numero_nit.value,
        //       "nrc": this.informacion_empresa.numero_registro.value,
        //       "nombre_empresa": this.informacion_empresa.nombre_empresa.value,
        //       "nombre_comercial": this.informacion_empresa.nombre_comercial_empresa.value === ''
        //           ? null : this.informacion_empresa.nombre_comercial_empresa.value,
        //       "id_pais": this.informacion_empresa.pais_origen_empresa.value,
        //       "id_tipo_persona": this.informacion_empresa.tipo_personeria.value,
        //       "matricula_comercial": this.informacion_empresa.numero_matricula_comercial.value,
        //       "id_tamanio_empresa": this.informacion_empresa.tamano_empresa.value,
        //       "id_municipio": this.ubicacion.municipio.value,
        //       "direccion": this.ubicacion.direccion.value,
        //       "sitio_web": this.dato_contacto.sitio_web.value !== "" ?
        //           this.dato_contacto.sitio_web.value : null,
        //       "anios_experiencia": parseInt(this.informacion_empresa.experiencia.value),
        //       "email": this.dato_contacto.correo_empresa.value,
        //       "tipos": this.tiposEmpresas,
        //       "sales": parseFloat(this.informacion_empresa.sales.value)
        //     }).then((response) => {
        //
        //   window.localStorage.setItem('InfoEmpresas', JSON.stringify(response.data))
        //   this.InfoEmpresa = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
        //   if (this.dato_contacto.telefonos.value.length !== 0) {
        //     this.GuardarDatosTelefono(this.dato_contacto.telefonos.value)
        //   }
        //
        //   if (this.informacion_empresa.giros.value.length !== 0 && this.informacion_empresa.giros.value.length <= 3) {
        //     this.GuardarDatosGiros(this.informacion_empresa.giros.value)
        //   } else {
        //   }
        //
        //   if (this.fotoRnc.length !== 0) {
        //     this.GuardarFotoRnc(this.fotoRnc)
        //   } else {
        //     this.informacion_empresa.foto_numero_registro.state = true
        //   }
        //
        //   if (this.fotoNit.length !== 0) {
        //     this.GuardarFotoNit(this.fotoNit)
        //   } else {
        //     this.informacion_empresa.foto_nit.state = true
        //   }
        //
        //   if (this.informacion_empresa.giros.value.length !== 0) {
        //   } else {
        //     this.informacion_empresa.giros.state = true
        //   }
        //
        //   // if (this.informacion_empresa.giros.value.length !== 0 && this.fotoRnc.length > 0 && this.fotoNit.length > 0) {
        //   // }
        //   this.step = this.step + 1
        //   this.parametros.forEach(row => {
        //     if (row.codigo === this.step) {
        //       row.isActive = true
        //     }
        //   })
        // }).catch(error => {
        // if (error.response.status === 303) {
        //   axios.put(this.url + '/api/v1/empresas/' + this.InfoEmpresa.id,
        //       {
        //         "nombre_empresa": this.informacion_empresa.nombre_empresa.value,
        //         "nombre_comercial": this.informacion_empresa.nombre_comercial_empresa.value,
        //         "id_pais": this.informacion_empresa.pais_origen_empresa.value,
        //         "id_tipo_persona": this.informacion_empresa.tipo_personeria.value,
        //         "id_tamanio_empresa": this.informacion_empresa.tamano_empresa.value,
        //         "id_municipio": this.ubicacion.municipio.value,
        //         "direccion": this.ubicacion.direccion.value,
        //         "sitio_web": this.dato_contacto.sitio_web.value !== "" ?
        //             this.dato_contacto.sitio_web.value : null,
        //         "anios_experiencia": parseInt(this.informacion_empresa.experiencia.value),
        //         "tipos": this.tiposEmpresas,
        //         "sales": parseFloat(this.informacion_empresa.sales.value)
        //       }).then((response) => {
        //     this.$store.dispatch('Fodes/setInfoEmpresa')
        //     if (this.informacion_empresa.giros.value.length !== 0 && this.informacion_empresa.giros.value.length <= 3) {
        //       this.GuardarDatosGiros(this.informacion_empresa.giros.value)
        //     } else {
        //       this.informacion_empresa.giros.state = true
        //     }
        //     if (this.dato_contacto.telefonos.value.length !== 0) {
        //       this.GuardarDatosTelefono(this.dato_contacto.telefonos.value)
        //     }
        //     if (this.fotoRnc.length !== 0) {
        //       this.GuardarFotoRnc(this.fotoRnc)
        //     } else {
        //       this.informacion_empresa.foto_numero_registro.state = true
        //     }
        //
        //     if (this.fotoNit.length !== 0) {
        //       this.GuardarFotoNit(this.fotoNit)
        //     } else {
        //       this.informacion_empresa.foto_nit.state = true
        //     }
        //     if (this.informacion_empresa.giros.value.length !== 0
        //         && this.dato_contacto.telefonos.value !== 0
        //         && this.fotoNit.length !== 0 && this.fotoRnc.length !== 0) {
        //       this.step = this.step + 1
        //       this.parametros.forEach(row => {
        //         if (row.codigo === this.step) {
        //           row.isActive = true
        //         }
        //       })
        //     }
        //   })
        // }
        // if (error.response.status === 400) {
        //   this.step = 1
        //   this.verificacion = true
        //   this.dato_contacto.sitio_web.value !== null && regexp.test(this.dato_contacto.sitio_web.value) === false ?
        //       (this.dato_contacto.sitio_web.state = true,
        //           this.dato_contacto.sitio_web.message = 'formato web invalido') : null
        // }
        // }).finally(()=> {
        // })
      } else {
        this.informacion_empresa.numero_registro.value == null ||
        this.informacion_empresa.numero_registro.value === ''  ||
        !validaNRC ? this.informacion_empresa.numero_registro.state = true
            : this.informacion_empresa.numero_registro.state = false

        this.informacion_empresa.numero_nit.value == null ||
        this.informacion_empresa.numero_nit.value === ''  ||
        !validaNit ? this.informacion_empresa.numero_nit.state = true
            : this.informacion_empresa.numero_nit.state = false

        this.dato_contacto.sitio_web.value !== null && regexp.test(this.dato_contacto.sitio_web.value) === false ?
            (this.dato_contacto.sitio_web.state = true,
                this.dato_contacto.sitio_web.message = 'formato web invalido') : null

        this.informacion_empresa.nombre_empresa.value == null ||
        this.informacion_empresa.nombre_empresa.value === '' ? this.informacion_empresa.nombre_empresa.state = true
            : this.informacion_empresa.nombre_empresa.state = false

        this.informacion_empresa.experiencia.value === null ||
        this.informacion_empresa.experiencia.value === '' || this.informacion_empresa.experiencia.value === 0 ? this.informacion_empresa.experiencia.state = true
            : this.informacion_empresa.experiencia.state = false

        this.informacion_empresa.numero_iva.value == null ||
        this.informacion_empresa.numero_iva.value === '' ? this.informacion_empresa.numero_iva.state = true
            : this.informacion_empresa.numero_iva.state = false

        this.validateForm() ? this.informacion_empresa.numero_matricula_comercial.state = false : this.informacion_empresa.numero_matricula_comercial.state = true

        !this.informacion_empresa.sales.value || this.informacion_empresa.sales.value === '' ?
            this.informacion_empresa.sales.state = true : this.informacion_empresa.sales.state = false

        this.informacion_empresa.pais_origen_empresa.value == null ||
        this.informacion_empresa.pais_origen_empresa.value === '' ? this.informacion_empresa.pais_origen_empresa.state = true
            : this.informacion_empresa.pais_origen_empresa.state = false

        this.informacion_empresa.tamano_empresa.value == null ||
        this.informacion_empresa.tamano_empresa.value === '' ? this.informacion_empresa.tamano_empresa.state = true
            : this.informacion_empresa.tamano_empresa.state = false

        this.informacion_empresa.tipo_personeria.value == null || this.informacion_empresa.tipo_personeria.value === '' ? this.informacion_empresa.tipo_personeria.state = true : this.informacion_empresa.tipo_personeria.state = false

        this.informacion_empresa.giros.value.length === 0 || this.informacion_empresa.giros.value == null ? this.informacion_empresa.giros.state = true : this.informacion_empresa.giros.state = false
        this.dato_contacto.telefonos.value.length === 0 || this.dato_contacto.telefonos.value == null ? this.dato_contacto.telefonos.state = true : this.dato_contacto.telefonos.state = false

        this.ubicacion.departamento.value == null || this.ubicacion.departamento.value === '' || this.ubicacion.departamento.value === 0 ? this.ubicacion.departamento.state = true : this.ubicacion.departamento.state = false

        this.ubicacion.municipio.value == null || this.ubicacion.municipio.value === '' ? this.ubicacion.municipio.state = true : this.ubicacion.municipio.state = false

        this.ubicacion.direccion.value == null || this.ubicacion.direccion.value === '' ? this.ubicacion.direccion.state = true : this.ubicacion.direccion.state = false

        this.dato_contacto.correo_empresa.value == null ||
        this.dato_contacto.correo_empresa.value === '' ? (this.dato_contacto.correo_empresa.state = true)
            : this.dato_contacto.correo_empresa.state = false

        this.fotoNit.length === 0 || this.fotoNit == null ? this.informacion_empresa.foto_nit.state = true : this.informacion_empresa.foto_nit.state = false

        this.fotoRnc.length === 0 || this.fotoRnc == null ? this.informacion_empresa.foto_numero_registro.state = true
            : this.informacion_empresa.foto_numero_registro.state = false
        this.verificacion = true

        this.informacion_empresa.isValidEmail === false ? this.informacion_empresa.isValidEmailmessage = 'Ingrese correo valido' : this.informacion_empresa.isValidEmailmessage = ''
        // validData
        if (!long_nombre_empresa) {
          this.informacion_empresa.nombre_empresa.state = true
          this.informacion_empresa.nombre_empresa.message = 'Debe de ingresar hasta 100 caracteres'
        }
        if (!long_nombre_comercial_empresa) {
          this.informacion_empresa.nombre_comercial_empresa.state = true
          this.informacion_empresa.nombre_comercial_empresa.message = 'Debe de ingresar hasta 100 caracteres'
        }
        if (!long_numero_matricula_comercial) {
          this.informacion_empresa.numero_matricula_comercial.state = true
          this.informacion_empresa.numero_matricula_comercial.message = 'Debe de ingresar hasta 50 caracteres'
        }
        if (!long_sales) {
          this.informacion_empresa.sales.message = 'A excedido el valor máximo permitido'
          this.informacion_empresa.sales.state = true
        }
        if (!long_experiencia) {
          this.informacion_empresa.experiencia.message = 'A excedido el valor máximo permitido'
          this.informacion_empresa.experiencia.state = true
        }
        if (!long_direccion) {
          this.ubicacion.direccion.state = true
          this.ubicacion.direccion.message = 'Debe de ingresar hasta 255 caracteres'
        }
        if (!long_correo_empresa) {
          this.dato_contacto.correo_empresa.state = true
          this.dato_contacto.correo_empresa.message = 'Debe de ingresar hasta 100 caracteres'
        }
        if (!long_sitio_web) {
          this.dato_contacto.sitio_web.state = true
          this.dato_contacto.sitio_web.message = 'Debe de ingresar hasta 100 caracteres'
        }
        this.loader = false
      }
    },

    GuardarDatosGiros(data) {
      if (data.length > 0) {
        let id = this.InfoEmpresa.id
        if (id > 0) {
          axios.get(this.url + '/api/v1/empresas/' + id + '/giros',
              {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then((response) => {
            this.girosempresa = response.data
            let giros = []
            let giroExiste
            data.forEach(row => {
              if (data.length < 4) {
                giroExiste = this.girosempresa.find(Giro => Giro.id === row.id)
                if (!giroExiste) {
                  giros.push({'id_tipo_giro': row['No.'], 'id_giro': row['id']})
                }
              }
            })
            if (giros.length > 0) {
              axios.post(this.url + '/api/v1/empresas/' + this.InfoEmpresa.id + '/giros',
                  giros
              ).then((response) => {
                let inforesponse = response.data
                let tipogiro = 0
                tipogiro = tipogiro + 1
                inforesponse.forEach(row => {
                  if (data.length < 4) {
                    this.informacion_empresa.giros.value = []
                    window.localStorage.setItem('informacion_empresa', JSON.stringify(this.informacion_empresa))
                    this.informacion_empresa.giros.value.push({
                      'No.': tipogiro,
                      'Actividad o giro': row.nombre_giro,
                      'id': row.id
                    })
                    window.localStorage.setItem('informacion_empresa', JSON.stringify(this.informacion_empresa))
                  }
                })
              }).catch(error => {
              })
            }
          }).finally(() => {
            this.loader = false
          });
        }
      }
    },

    GuardarDatosTelefono(data) {
      let telefonos = []
      let numeroExiste
      data.forEach(row => {
        numeroExiste = this.InfoEmpresa.contactos.find(Telefono => Telefono.contacto === row.Telefono);
        if (!numeroExiste) {
          telefonos.push({'id_tipo_contacto': 1, 'contacto': row.Telefono})
        }
      })
      if (telefonos.length > 0) {
        axios.post(this.url + '/api/v1/empresas/' + this.InfoEmpresa.id + '/contactos',
            telefonos
        ).then((response) => {
          let dato_contactoresponse = response.data
          this.dato_contacto.telefonos.value = []
          window.localStorage.setItem('dato_contacto', JSON.stringify(this.dato_contacto))
          this.dato_contacto.telefonos.value = []
          window.localStorage.setItem('dato_contacto', JSON.stringify(this.dato_contacto))
          dato_contactoresponse.forEach(row => {
            this.dato_contacto.telefonos.value.push({
              'Telefono': row.contacto,
              'id_tipo_contacto': row.id_tipo_contacto, 'id': row.id
            })
          })
          window.localStorage.setItem('dato_contacto', JSON.stringify(this.dato_contacto))
        }).finally(() => {
          this.loader = false
        });
      }
    },

    CambiarEstado() {
      if (this.exito === 1 && this.informacion_autorizado_legal.telefonos.value.length <= 0 || this.exito === 2 && this.dato_contacto.telefonos.value.length > 0
          || this.exito === 2 && this.dato_contacto.telefonos.value.length <= 0 || this.exito === 1 && this.informacion_autorizado_legal.telefonos.value.length > 0) {
        axios.post(this.url + '/api/v1/empresas/' + this.InfoEmpresa.id + '/estados', {"id_estado": 3}).then((response) => {
          window.localStorage.clear()
          this.$router.push('/empresas/final')
        })
      }
    },

    async comprobar_correo(correo) {
      try {

       const response = await this.http_client('/api/v1/personas/' + this.informacion_autorizado_legal.id_persona + '/contactos', correo, 'post')
        if (response.status === 201) {
          this.exito = this.exito + 1
          if (parseInt(this.$route.params.id) !== 1) {
            //await this.relacionarInfoRepresentante()
         //   await this.GuardarFotoDUIPersona(this.fotoDuiPersona)
          //await  this.GuardarFotoNitPersona(this.fotoNitPersona)
          }
         // this.GuardarDatosTelefonoPersona(this.informacion_autorizado_legal.telefonos.value)
        }


      } catch (error) {
        this.$toast.warning('Otra persona ya se encuentra registrada con este correo')
      }
    },
    GuardarDatosTelefonoPersona(data) {
      let telefonos = []
      if (data.length > 0) {
        data.forEach(row => {
          telefonos.push({'id_tipo_contacto': 1, 'contacto': row['Telefono']})
        })
        axios.post(this.url + '/api/v1/personas/' + this.informacion_autorizado_legal.id_persona + '/contactos',
            telefonos
        ).then((response) => {
          let data = response.data
          this.informacion_autorizado_legal.telefonos.value = []
          window.localStorage.setItem('informacion_autorizado_legal', JSON.stringify(this.informacion_autorizado_legal))
          data.forEach(row => {
            this.informacion_autorizado_legal.telefonos.value.push({
              'Telefono': row.contacto,
              'id_tipo_contacto': row.id_tipo_contacto, 'id': row.id
            })
          })
          window.localStorage.setItem('informacion_autorizado_legal', JSON.stringify(this.informacion_autorizado_legal))
          this.exito = this.exito + 1
          this.CambiarEstado()
        }).catch(error => {
          this.exito = 0
        }).finally(()=> {
          this.loader = false
        });
      } else {
        this.loader = false
      }
    },
    GuardarDatosCorreoPersona(data) {
      let correo = []

      if (data !== null && this.informacion_autorizado_legal.isValidEmail === true) {
        correo.push({'id_tipo_contacto': 2, 'contacto': this.informacion_autorizado_legal.correo_empresa.value})
        this.comprobar_correo(correo)
      } else {
        this.informacion_autorizado_legal.correo_empresa.value == null || this.informacion_autorizado_legal.correo_empresa.value === '' ? this.informacion_autorizado_legal.correo_empresa.state = true : this.informacion_autorizado_legal.correo_empresa.state = false
        window.localStorage.setItem('informacion_autorizado_legal', JSON.stringify(this.informacion_autorizado_legal))
        this.informacion_autorizado_legal.isValidEmail === false ? this.informacion_autorizado_legal.isValidEmailmessage = 'Ingrese correo valido' : this.informacion_autorizado_legal.isValidEmailmessage = ''
      }
    },

    GuardarFotoNit(data) {
      if (typeof data !== 'string') {
        let form = new FormData();
        form.append('nit', data);
        const headers =
            {'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'}

        axios.post(this.url + '/api/v1/empresas/' +
            this.InfoEmpresa.id + '/nit', form, {
          headers: headers
        }).then((response) => {
        })
      }
    },
    GuardarFotoRnc(data) {
      if (typeof data !== 'string') {
        let form = new FormData();
        form.append('nrc', data);
        const headers = {'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'}
        axios.post(this.url + '/api/v1/empresas/' +
            this.InfoEmpresa.id + '/nrc', form, {
          headers: headers
        }).then((response) => {
        })
      }
    },
    async GuardarFotoDUIPersona(data) {
      if (data.length !== 0) {
        let form = new FormData();
        form.append('id_tipo_documento', 15);
        form.append('documento', data);
        const headers =
            {'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'}
        axios.post(this.url + '/api/v1/empresas/' +
            this.InfoEmpresa.id + '/documentos', form, {
          headers: headers
        }).then((response) => {
        }).catch(error => {
          if (error.response.status === 400) {
          }
        })
      } else {
        this.informacion_representante.foto_dui.state = true
        this.setData()
      }
    },
    GuardarFotoNitPersona(data) {
      this.exito = 0
      if (data.length !== 0) {
        let form = new FormData();
        form.append('id_tipo_documento', 14);
        form.append('documento', data);
        const headers = {'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'}

        axios.post(this.url + '/api/v1/empresas/' +
            this.InfoEmpresa.id + '/documentos', form, {
          headers: headers
        }).then((response) => {
          this.exito = this.exito + 1
          if (response.status === 200) {
          }
          if (this.informacion_autorizado_legal.telefonos.value.length <= 0) {
            this.CambiarEstado()
          }
        }).catch(error => {
          if (error.response.status === 400) {
            this.exito = this.exito + 1
            if (this.informacion_autorizado_legal.telefonos.value.length <= 0) {
              this.CambiarEstado()
            }
          }
        })
      } else {
        this.informacion_representante.foto_nit.state = true
        this.setData(4)
      }
    },

    async setData() {
      this.InfoEmpresa = JSON.parse(window.localStorage.getItem('InfoEmpresas'))

      this.informacion_empresa = JSON.parse(window.localStorage.getItem('informacion_empresa'))
      this.ubicacion = JSON.parse(window.localStorage.getItem('ubicacion'))
      this.dato_contacto = JSON.parse(window.localStorage.getItem('dato_contacto'))
      try {
        if (this.fotoNit.length === 0) {
          if (window.localStorage.getItem('fotoNIT')) {
            this.$store.dispatch('Fodes/setDataFotos', {
              'fotonit': window.localStorage.getItem('fotoNIT'),
              'tipo': 1
            })
          }
        }
      }  catch (e) {
      }
      try {
        if (this.fotoRnc.length === 0) {
          if (window.localStorage.getItem('fotoRNC')) {
            this.$store.dispatch('Fodes/setDataFotos', {
              'fotornc': window.localStorage.getItem('fotoRNC'),
              'tipo': 2
            })
          }
        }
      }  catch (e) {
      }
    },
    cancelar() {
      window.localStorage.clear()
      if (this.$route.params.id === 'proceso') {
        this.$router.push('/empresas/index/proceso')
      } else {
        this.$router.push('/empresas/index')
      }
    },
    GuardarDatos() {
    },
    revisarNIT() {
      let nit = window.localStorage.getItem('InfoEmpresas')
      if (nit) {
      } else {
        window.localStorage.clear()
        this.$router.push('/empresas/index')
      }
    },
    createVars() {
      if (this.ubicacion == null) {
        let ubicacionArray = []
        ubicacionArray =
            {
              'departamento': {value: null, state: null, name: null, message: 'Departamento es requerido *'},
              'municipio': {value: null, state: null, name: null, message: 'Municipio es requerido *'},
              'direccion': {value: null, state: null, message: 'Direccion es requerido *'}
            }
        this.ubicacion = ubicacionArray
        window.localStorage.setItem('ubicacion', JSON.stringify(this.ubicacion))
      }
      if (this.dato_contacto == null) {
        let datocontactoArray = []
        datocontactoArray =
            {
              'correo_empresa': {value: null, state: null, message: 'Correo electronico es requerido *'},
              'telefonos': {value: [], state: null, message: ''},
              'sitio_web': {value: null, state: null, message: ''}
            }
        this.dato_contacto = datocontactoArray
        window.localStorage.setItem('dato_contacto', JSON.stringify(this.dato_contacto))
      }
    },
    validateForm() {
      if (this.informacion_empresa.tipo_personeria.value === 2) {
        return this.informacion_empresa.numero_matricula_comercial.value !== null && this.informacion_empresa.numero_matricula_comercial.value !== '';
      } else {
        return true;
      }
    },
    validateDocuments() {
      if (this.$route.params.id === 'proceso') {
        return true;
      } else {
        return this.fotoNit !== null && this.fotoNit.length !== 0 && this.fotoRnc !== null && this.fotoRnc.length !== 0;
      }
    },
    validateNitEmpresa() {
      let respuesta = false
      if (this.informacion_empresa.numero_nit.value === null || this.informacion_empresa.numero_nit.value === "") {
        this.informacion_empresa.numero_nit.state = true
        respuesta = false
      } else if (isNit(this.informacion_empresa.numero_nit.value) || isDui(this.informacion_empresa.numero_nit.value)) {
        respuesta = true
      } else {

        this.informacion_empresa.numero_nit.message = 'NIT no valido'
        respuesta = false
      }
      return respuesta
    },
    validateNRCEmpresa() {
      let respuesta2 = false
      if (this.informacion_empresa.numero_registro.value === null || this.informacion_empresa.numero_registro.value === "") {

        this.informacion_empresa.numero_registro.state = true
        respuesta2 = false
      } else {
        if (this.informacion_empresa.numero_registro.value.length <= 1 || this.informacion_empresa.numero_registro.value.length > 14) {

          this.informacion_empresa.numero_registro.message = 'NRC debe ser igual o menor a trece digitos y mayor que uno'
          respuesta2 = false
        } else {
          respuesta2 = true
        }
      }
      return respuesta2
    },
  },
  mounted() {
    this.setData()
    this.revisarNIT()
    this.createVars()
  },
  computed: {
    ...mapGetters({
      fotoNit: 'Fodes/getFotoNit',
      fotoRnc: 'Fodes/getFotoRnc',
      fotoMatricula: 'Fodes/getFotoMatricula',
      fotoNitPersona: 'Fodes/getFotoNitPersona',
      fotoDuiPersona: 'Fodes/getFotoDuiPersona',
      fotoCarnetPersona: 'Fodes/getFotoCarnetPersona'
    })
  },
  watch: {
    step: function () {
      if (this.step === 2) {
        this.$store.dispatch('Fodes/setStep', 2)
      }
      if (this.step === 1) {
        this.$store.dispatch('Fodes/setStep', 1)
      }
      if (this.step === 3) {
        this.step = 2
      }
      this.loader = false
    }
  }
}
</script>

<style scoped>

</style>
